import { X } from "react-feather";
import React from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import TextInput from "../Formik/TextInput";
import DropdownSelect from "../Formik/DropdownSelect";

export const ModalAddEditThesaurus = ({item = null, products = [], onHandleToggle, handleAction, title, message, errorMessage}) => {
    const isEdit = Boolean(item);

    const formik = useFormik({
        initialValues: {
            name: item?.name || "",
            product: isEdit ? item : ""

        },
        validationSchema: Yup.object({
            name: Yup.string()
                .trim()
                .max(60, "Thesaurus name cannot exceed 60 characters.")
                .required("Thesaurus name is required."),
            product: Yup.object().required("Product is required.")
        }),
        onSubmit: (values) => {
            handleAction({
                id: item?.id,
                productId: values.product?.id,
                thesaurus: values.name
            });
        }
    });

    const selectProduct = (item) => {
        formik.setFieldValue('product', item);
    };

    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    {title}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>
            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div className="sl-text-md sl-font-normal sl-text-gray-700">
                        {message}
                    </div>

                    <div className={'sl-mt-4'}>
                        <TextInput formik={formik} label={'Thesaurus name'} name={'name'}/>
                        {!isEdit && <DropdownSelect
                            formik={formik}
                            label={'Product'}
                            name={'product'}
                            selectedItem={formik.values.product}
                            fieldDefaultText={'Select product'}
                            options={products}
                            onChange={selectProduct}
                            elementClasses={'sl-mt-2 sl-text-left sl-overflow-y-hidden'}
                        >
                        </DropdownSelect>}
                    </div>

                    <div className="sl-text-error-500 sl-mt-4 sl-font sl-text-sm sl-font">
                        {errorMessage}
                    </div>
                </div>
            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg ">
                        Cancel
                    </button>
                    <button onClick={formik.submitForm}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalAddEditThesaurus;
